import { Typography } from "@mui/material";
import { ReviewsTable } from "./reviews-table";

import type { FC } from "react";

export const PreviousReviewsTab: FC = () => (
  <>
    <Typography variant="body2" sx={{ mb: 4 }}>
      These are Communications you were previously asked to approve, that have now been published.
      Creators can publish Communications without the approval being completed.
    </Typography>
    <ReviewsTable variant="previous" />
  </>
);
